import api from '@/api';

const { $student} = api;

export const {$students, $studentCertificatePel} = $student;
